module.exports = __webpack_public_path__ + "media/assets/images/flags/gu-736d50760763015232170f2b0f924077.svg";